/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type EmployeeResourceGroupInteractionsQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['UUID']['input'];
  dateFrom?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  dateTo?: Types.InputMaybe<Types.Scalars['Date']['input']>;
  categoryIds?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['UUID']['input']>> | Types.InputMaybe<Types.Scalars['UUID']['input']>>;
  applicationResourceId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  orderBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type EmployeeResourceGroupInteractionsQuery = { __typename: 'Query', clientEmployeeApplicationInteractions?: { __typename: 'ClientEmployeeApplicationInteractionsResultType', totalCount: number, filteredCount: number, interactions: Array<{ __typename: 'ClientEmployeeApplicationInteractionType', lastInteractionAt: string, firstInteractionAt: string, totalInteractions: number, application: { __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string } }, resourceGroup: { __typename: 'TenantedResourceGroupType', id: string }, primaryResource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, vendorName?: string | null, productDescription?: string | null, productDomainName?: string | null, publicResource: { __typename: 'ResourceType', productName?: string | null, vendorName?: string | null, signedLogoUrl?: string | null, category?: { __typename: 'ResourceCategoryType', id: string, name: string, parent?: { __typename: 'ResourceCategoryType', id: string, name: string } | null } | null } }, relatedApplications?: Array<{ __typename: 'ClientApplicationType', id: string, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null } }> | null }> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const EmployeeResourceGroupInteractionsDocument = new TypedDocumentString(`
    query EmployeeResourceGroupInteractions($employeeId: UUID!, $dateFrom: Date, $dateTo: Date, $categoryIds: [UUID], $applicationResourceId: UUID, $orderBy: String, $offset: Int, $limit: Int) {
  clientEmployeeApplicationInteractions(
    clientEmployeeId: $employeeId
    dateFrom: $dateFrom
    dateTo: $dateTo
    categoryIds: $categoryIds
    applicationResourceId: $applicationResourceId
    orderBy: $orderBy
    offset: $offset
    limit: $limit
  ) {
    totalCount
    filteredCount
    interactions {
      application {
        id
        resource {
          id
        }
      }
      resourceGroup {
        id
      }
      primaryResource {
        id
        productName
        vendorName
        productDescription
        productDomainName
        publicResource {
          productName
          vendorName
          signedLogoUrl
          category {
            id
            name
            parent {
              id
              name
            }
          }
        }
      }
      lastInteractionAt
      firstInteractionAt
      totalInteractions
      relatedApplications {
        id
        resource {
          id
          productName
        }
      }
    }
  }
}
    `);

export const useEmployeeResourceGroupInteractionsQuery = <
      TData = EmployeeResourceGroupInteractionsQuery,
      TError = unknown
    >(
      variables: EmployeeResourceGroupInteractionsQueryVariables,
      options?: Omit<UseQueryOptions<EmployeeResourceGroupInteractionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<EmployeeResourceGroupInteractionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<EmployeeResourceGroupInteractionsQuery, TError, TData>(
      {
    queryKey: ['EmployeeResourceGroupInteractions', variables],
    queryFn: fetcher<EmployeeResourceGroupInteractionsQuery, EmployeeResourceGroupInteractionsQueryVariables>(EmployeeResourceGroupInteractionsDocument, variables),
    ...options
  }
    )};

useEmployeeResourceGroupInteractionsQuery.getKey = (variables: EmployeeResourceGroupInteractionsQueryVariables) => ['EmployeeResourceGroupInteractions', variables];

export const useInfiniteEmployeeResourceGroupInteractionsQuery = <
      TData = InfiniteData<EmployeeResourceGroupInteractionsQuery>,
      TError = unknown
    >(
      variables: EmployeeResourceGroupInteractionsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<EmployeeResourceGroupInteractionsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<EmployeeResourceGroupInteractionsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<EmployeeResourceGroupInteractionsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['EmployeeResourceGroupInteractions.infinite', variables],
      queryFn: (metaData) => fetcher<EmployeeResourceGroupInteractionsQuery, EmployeeResourceGroupInteractionsQueryVariables>(EmployeeResourceGroupInteractionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteEmployeeResourceGroupInteractionsQuery.getKey = (variables: EmployeeResourceGroupInteractionsQueryVariables) => ['EmployeeResourceGroupInteractions.infinite', variables];


useEmployeeResourceGroupInteractionsQuery.fetcher = (variables: EmployeeResourceGroupInteractionsQueryVariables) => fetcher<EmployeeResourceGroupInteractionsQuery, EmployeeResourceGroupInteractionsQueryVariables>(EmployeeResourceGroupInteractionsDocument, variables);
